import Plugin from 'src/plugin-system/plugin.class';

export default class EinzugsgebietPunktePlugin extends Plugin {

    init() {
        //$('.einzugsgebiet-karte-widget__drop-1, .einzugsgebiet-karte-widget__drop-2, .einzugsgebiet-karte-widget__drop-3').tooltip()
    }

}